module.exports = __webpack_public_path__ + "img/icommunity_sys-08_de.1804c7c2.jpg";